/**
    * @description      :
    * @author           :
    * @group            :
    * @created          : 21/07/2021 - 10:38:47
    *
    * MODIFICATION LOG
    * - Version         : 1.0.0
    * - Date            : 21/07/2021
    * - Author          :
    * - Modification    :
* */
import styled from 'styled-components';
import { Typography, Button } from 'antd';

const { Title, Text } = Typography;

export const Container = styled.div`
  background: #fff;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  flex: 1;
  height: 100%;
  flex-direction: column;

  @media (max-width: 767px) {
    > .ant-row {
      gap: 12px;
    }

    > .ant-row > .ant-row:first-child {
      width: auto !important;
      min-width: 0;
      flex: 1;
    }

    > .ant-row > .ant-row:last-child {
      width: auto !important;
      flex: 0 0 auto;

      p {
        display: none;
      }
    }
  }
`;

export const CaixaTitulo = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  .icone {
    margin-left: 10px;
    font-size: 20px;
  }

  @media (max-width: 767px) {
    min-width: 0;
  }
`;

export const Titulo = styled(Title)`
  color: #222;
  margin: 0 !important;
  padding: 0 !important;
  line-height: 1 !important;
  align-self: center;

  @media (max-width: 767px) {
    overflow: hidden;
    font-size: 18px !important;
    line-height: 1.2 !important;
    text-overflow: ellipsis;
  }
`;

export const Texto = styled(Text)`
  color: #666666;
  line-height: 1;
  padding-bottom: 5px;
  font-size: 12px;
`;

export const BotaoVoltar = styled(Button)`
  color: #fff;
  background: #24A95D;
  border-color: #24A95D;
  &:hover {
    background: #24A95D;
    border-color: #24A95D;
    color: #fff;
  }
`;
